import { Col } from "@commonlibs";
import TextField from "ui/common/components/input/TextField/TextField";
import useTranslate from "ui/locale/hooks/useTranslate";
import useParsePhoneNumber from "ui/common/hooks/useParsePhoneNumber";
import { PhoneInputRoot } from "./ModifyReleaseStrategyForm.styles";
import ApproversAutocomplete from "../ApproversAutocomplete/ApproversAutocomple";
import type { ApproverDto } from "common/models/api/models/ApproverDto";
import { ModifyReleaseStrategyFormProps } from "./ModifyRelaseStrategyForm.types";

export default function ModifyReleaseStrategyForm({ onChange, onSetForm, approver, phoneInputKey }: ModifyReleaseStrategyFormProps) {
    const translate = useTranslate();

    function onAutocompleteChange(value: ApproverDto | null) {
        if (!value) return;
        onSetForm(value);
    }

    return (
        <Col gap={15}>
            <ApproversAutocomplete
                defaultSearch={approver?.email}
                css={{ flex: 1, maxWidth: "100%" }}
                placeholder={translate("emailPlaceholder")}
                label={translate("approverEmail")}
                onChange={onAutocompleteChange}
                onSearchChange={(value) => {
                    onChange("email", value);
                }}
            />
            <TextField
                value={approver?.name}
                onChange={(value) => onChange("name", value)}
                placeholder={translate("name")}
                label={translate("name")}
            />
            <PhoneInputRoot
                key={phoneInputKey}
                style={{ height: "100%" }}
                defaultValue={useParsePhoneNumber(approver?.phone) || ["57", ""]}
                label={translate("phone")}
                placeholder={translate("phone")}
                required
                onPhoneInputChange={(value) => {
                    onChange("phone", `+${value![0]}${value![1]}`);
                }}
            />
        </Col>
    );
}
